<template>
  <div class="cart_items">
    <cart_item v-for="item in items" :key="item.key" :this_key="item.key" :points="item.points" :variant_metafields="item.variant_metafields" :is_new="item.customAttributes && item.customAttributes.new" :is_hidden="item.dont_render_anchors" :show_variant_info="!item.product_has_only_default_variant && !item.gift_card" v-bind="item" limit="5"></cart_item>
  </div>
</template>

<script>
  export default {
    name: 'cart_items',
    props: ['items'],
  }
</script>